import styled from "styled-components";
import {Button} from "antd";

export const CompanySettingButton = styled(Button)`
    ${({activityCondition}) => activityCondition && activityCondition == true ? `background: #d4ffd6;` : activityCondition == "some" ? `background: linear-gradient(to bottom right, #fff 0%, #fff 50%, #d4ffd6 50%, #d4ffd6 100%);` : ``}
`;
